import AuthProvider from "providers/AuthProvider";
import { useRef } from "react";
import { useSelector } from "react-redux";
import { Navigate, Route, Routes } from "react-router-dom-v5-compat";

import { isSignedIn } from "seneca-common/features/user/state";

import ProtectedRoute from "features/common/routing/ProtectedRoute";
import { linkToParentDashboard } from "features/parents/links";
import { linkToSignIn } from "features/sign-up/links";
import { ROUTES } from "routing/routes";

import LocationProvider from "./LocationProvider";
import PasswordlessParentCheckYourEmail from "./passwordless/ParentCheckYourEmail";
import SignUpParent from "./SignUpParent";
import SignUpParentUserDetails from "./SignUpParentUserDetails";
import SignUpParentWrapper from "./SignUpParentWrapper";

const { USER_DETAILS, CHECK_YOUR_EMAIL } = ROUTES.SIGN_UP_PARENT.$;

export default function SignUpParentRoute() {
  const signedIn = useSelector(isSignedIn);
  const isSignedInOnMount = useRef(signedIn).current;

  return (
    <LocationProvider>
      <Routes>
        <Route element={<SignUpParentWrapper />}>
          <Route
            index
            element={
              <ProtectedRoute
                isAllowed={!isSignedInOnMount}
                redirectPath={linkToParentDashboard()}
              >
                <SignUpParent />
              </ProtectedRoute>
            }
          />
          <Route
            path={USER_DETAILS.relativePath}
            element={
              <AuthProvider>
                <SignUpParentUserDetails />
              </AuthProvider>
            }
          />
          <Route
            path={CHECK_YOUR_EMAIL.relativePath}
            element={<PasswordlessParentCheckYourEmail />}
          />
          <Route path="*" element={<Navigate to={linkToSignIn()} />} />
        </Route>
      </Routes>
    </LocationProvider>
  );
}
